import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { menuService } from '../services/menuService';
import { Clock, Package, History, TrendingUp, DollarSign, CheckCircle2, AlertCircle, User, Phone, MapPin, Calendar, Receipt, LogOut, Check, X, Search, ChevronLeft, ChevronRight, AlertTriangle, Info } from 'lucide-react';
import * as signalR from '@microsoft/signalr';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PendingOrdersManagement = () => {
  const { user, restaurants, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('pending'); // 'pending', 'approved', 'detail', 'history'
  const [pendingOrders, setPendingOrders] = useState([]);
  const [approvedOrders, setApprovedOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [approvedLoading, setApprovedLoading] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [processingOrderId, setProcessingOrderId] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [orderToReject, setOrderToReject] = useState(null);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('info'); // 'success', 'error', 'info', 'warning'
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [confirmTitle, setConfirmTitle] = useState('');
  const [confirmCallback, setConfirmCallback] = useState(null);
  const [historyOrders, setHistoryOrders] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyFilters, setHistoryFilters] = useState({
    orderNumber: '',
    createdAt: '',
    startDate: '',
    endDate: '',
    status: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const connectionRef = useRef(null);
  const audioRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Bildirim sesi çal
  const playNotificationSound = () => {
    try {
      // Web Audio API ile bildirim sesi oluştur
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      // Ses ayarları
      oscillator.frequency.value = 800; // Frekans (Hz)
      oscillator.type = 'sine'; // Sinüs dalgası

      // Ses seviyesi (volume)
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);

      // Ses çal
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.3);

      // Cleanup
      oscillator.onended = () => {
        audioContext.close();
      };
    } catch (error) {
      console.error('Bildirim sesi çalınamadı:', error);
      // Fallback: Basit beep sesi
      try {
        const beep = new Audio('data:audio/wav;base64,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');
        beep.play().catch(err => console.error('Beep sesi çalınamadı:', err));
      } catch (fallbackError) {
        console.error('Fallback beep sesi çalınamadı:', fallbackError);
      }
    }
  };

  // RestaurantId'yi al
  const getRestaurantId = () => {
    if (restaurants && restaurants.length > 0) {
      return restaurants[0].id || restaurants[0].restaurantId || restaurants[0].ID || restaurants[0].RestaurantId;
    }
    
    // Token'dan al
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return null;
      
      const parts = token.split('.');
      if (parts.length !== 3) return null;
      
      const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64 + '='.repeat((4 - base64.length % 4) % 4);
      const decoded = atob(padded);
      const payload = JSON.parse(decoded);
      
      return payload.RestaurantId || null;
    } catch (error) {
      console.error('Error parsing RestaurantId from token:', error);
      return null;
    }
  };

  // SignalR Connection Setup
  useEffect(() => {
    const restaurantId = getRestaurantId();
    if (!restaurantId) return;

    const token = localStorage.getItem('authToken');
    if (!token) return;

    // SignalR Hub URL'ini oluştur (HTTPS -> WSS, HTTP -> WS)
      const baseUrl = API_BASE_URL || 'https://91.98.228.215:5001';
    const wsUrl = baseUrl.replace('https://', 'wss://').replace('http://', 'ws://');
    const hubUrl = `${wsUrl}/hubs/orders?restaurantId=${restaurantId}&access_token=${token}`;
    
    console.log('SignalR Hub URL:', hubUrl);
    
    // Connection oluştur
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets
      })
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: retryContext => {
          if (retryContext.previousRetryCount === 0) return 2000;
          if (retryContext.previousRetryCount === 1) return 5000;
          if (retryContext.previousRetryCount === 2) return 10000;
          return 30000;
        }
      })
      .build();

    // Tüm gelen mesajları yakalamak için (debug)
    const originalInvoke = connection.invoke;
    connection.invoke = function(...args) {
      console.log('📤 SignalR invoke:', args);
      return originalInvoke.apply(this, args);
    };

    // Yeni sipariş geldiğinde - Tüm event'leri dinle
    connection.on('ReceiveOrder', (data) => {
      console.log('🔔 ReceiveOrder event tetiklendi:', data);
      console.log('Data type:', typeof data);
      console.log('Data:', JSON.stringify(data, null, 2));
      
      if (data && data.type === 'NEW_ORDER' && data.order) {
        const newOrder = data.order;
        console.log('📦 Yeni sipariş objesi:', newOrder);
        console.log('📦 Sipariş durumu:', newOrder.status, typeof newOrder.status);
        
        // Sipariş durumunu kontrol et (sadece Pending olanları ekle)
        if (newOrder.status === 'Pending' || newOrder.status === 0 || newOrder.status === '0') {
          console.log('✅ Pending sipariş, listeye ekleniyor...');
          
          // Aynı sipariş zaten listede var mı kontrol et
          setPendingOrders(prevOrders => {
            const exists = prevOrders.some(order => order.orderId === newOrder.orderId);
            if (exists) {
              console.log('⚠️ Sipariş zaten listede var, eklenmedi');
              return prevOrders;
            }
            console.log('✅ Yeni sipariş listeye eklendi');
            // Yeni siparişi listenin başına ekle
            return [newOrder, ...prevOrders];
          });

          // Bildirim göster
          const alertMessage = data.message || `Yeni sipariş alındı: ${newOrder.orderNumber}`;
          console.log('📢 Bildirim gösteriliyor:', alertMessage);
          setAlertMessage(alertMessage);
          setAlertType('info');
          setShowAlertModal(true);
        } else {
          console.log('⚠️ Sipariş Pending değil, eklenmedi. Status:', newOrder.status);
        }
      } else {
        console.log('⚠️ Data formatı beklenen formatta değil:', data);
      }
    });

    // NewOrder event handler (Backend'den gelen gerçek event adı)
    connection.on('NewOrder', (data) => {
      console.log('🔔 NewOrder event tetiklendi:', data);
      console.log('Data type:', typeof data);
      console.log('Data:', JSON.stringify(data, null, 2));
      
      if (data && data.type === 'NEW_ORDER' && data.order) {
        const newOrder = data.order;
        console.log('📦 Yeni sipariş objesi:', newOrder);
        console.log('📦 Sipariş durumu:', newOrder.status, typeof newOrder.status);
        
        // Sipariş durumunu kontrol et (sadece Pending olanları ekle)
        // Status string olarak "Pending" veya number olarak 0 olabilir
        if (newOrder.status === 'Pending' || newOrder.status === 0 || newOrder.status === '0') {
          console.log('✅ Pending sipariş, listeye ekleniyor...');
          
          // Aynı sipariş zaten listede var mı kontrol et
          setPendingOrders(prevOrders => {
            const exists = prevOrders.some(order => order.orderId === newOrder.orderId);
            if (exists) {
              console.log('⚠️ Sipariş zaten listede var, eklenmedi');
              return prevOrders;
            }
            console.log('✅ Yeni sipariş listeye eklendi');
            // Yeni siparişi listenin başına ekle
            return [newOrder, ...prevOrders];
          });

          // Bildirim göster
          const alertMessage = data.message || `Yeni sipariş alındı: ${newOrder.orderNumber}`;
          console.log('📢 Bildirim gösteriliyor:', alertMessage);
          setAlertMessage(alertMessage);
          setAlertType('info');
          setShowAlertModal(true);
        } else {
          console.log('⚠️ Sipariş Pending değil, eklenmedi. Status:', newOrder.status);
        }
      } else {
        console.log('⚠️ Data formatı beklenen formatta değil:', data);
      }
    });

    // Alternatif event isimleri için de dinle (debug için)
    connection.on('OrderCreated', (data) => {
      console.log('🔔 OrderCreated event tetiklendi:', data);
    });

    // Tüm mesajları dinle (debug için)
    connection.onreconnecting(() => {
      console.log('🔄 SignalR yeniden bağlanıyor...');
    });

    connection.onreconnected(() => {
      console.log('✅ SignalR yeniden bağlandı');
    });

    // Connection başlat
    connection.start()
      .then(() => {
        console.log('✅ SignalR bağlantısı kuruldu');
        console.log('📡 Connection ID:', connection.connectionId);
        console.log('📡 Connection State:', connection.state);
        connectionRef.current = connection;
      })
      .catch((error) => {
        console.error('❌ SignalR bağlantı hatası:', error);
        console.error('❌ Error details:', JSON.stringify(error, null, 2));
      });

    // Connection durumu değişikliklerini dinle
    connection.onclose((error) => {
      console.log('🔴 SignalR bağlantısı kapandı', error);
    });

    connection.onreconnecting((error) => {
      console.log('SignalR yeniden bağlanıyor...', error);
    });

    connection.onreconnected((connectionId) => {
      console.log('SignalR yeniden bağlandı:', connectionId);
    });

    // Cleanup
    return () => {
      if (connectionRef.current) {
        connectionRef.current.stop();
        connectionRef.current = null;
      }
    };
  }, [restaurants]);

  // Bekleyen siparişleri yükle
  useEffect(() => {
    const loadPendingOrders = async () => {
      if (activeTab !== 'pending') return;
      
      const restaurantId = getRestaurantId();
      if (!restaurantId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const orders = await menuService.getPendingOrders(restaurantId);
        setPendingOrders(orders || []);
      } catch (error) {
        console.error('Error loading pending orders:', error);
        setPendingOrders([]);
      } finally {
        setLoading(false);
      }
    };

    loadPendingOrders();
    
    // Her 60 saniyede bir yenile (SignalR ile gerçek zamanlı güncelleme olduğu için interval'i uzattık)
    const interval = setInterval(loadPendingOrders, 60000);
    return () => clearInterval(interval);
  }, [activeTab, restaurants]);

  // Onaylanan siparişleri yükle
  useEffect(() => {
    const loadApprovedOrders = async () => {
      if (activeTab !== 'approved') return;
      
      const restaurantId = getRestaurantId();
      if (!restaurantId) {
        setApprovedLoading(false);
        return;
      }

      setApprovedLoading(true);
      try {
        const orders = await menuService.getApprovedOrders(restaurantId);
        setApprovedOrders(orders || []);
      } catch (error) {
        console.error('Error loading approved orders:', error);
        setApprovedOrders([]);
      } finally {
        setApprovedLoading(false);
      }
    };

    loadApprovedOrders();
    
    // Her 30 saniyede bir yenile
    const interval = setInterval(loadApprovedOrders, 30000);
    return () => clearInterval(interval);
  }, [activeTab, restaurants]);

  // Geçmiş siparişleri ara
  const handleSearch = async () => {
    const restaurantId = getRestaurantId();
    if (!restaurantId) {
      return;
    }

    setHistoryLoading(true);
    setCurrentPage(1); // Arama yapıldığında ilk sayfaya dön
    try {
      const orders = await menuService.getOrderHistory(restaurantId, historyFilters);
      setHistoryOrders(orders || []);
    } catch (error) {
      console.error('Error loading history orders:', error);
      setHistoryOrders([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  // İstatistikleri hesapla
  const calculateStats = () => {
    const pendingCount = pendingOrders.length;
    const todayRevenue = pendingOrders.reduce((sum, order) => {
      const orderDate = new Date(order.createdDate);
      const today = new Date();
      if (orderDate.toDateString() === today.toDateString()) {
        return sum + (order.totalAmount || 0);
      }
      return sum;
    }, 0);
    
    return {
      pending: pendingCount,
      todayRevenue: todayRevenue,
      completed: 0, // Gelecekte tamamlanan siparişler API'si eklenecek
      total: pendingCount
    };
  };

  const statsData = calculateStats();

  const tabs = [
    { id: 'pending', label: 'Bekleyen Siparişler', icon: Clock, color: 'orange' },
    { id: 'approved', label: 'Onaylanan Siparişler', icon: CheckCircle2, color: 'green' },
    { id: 'detail', label: 'Sipariş Detayı', icon: Package, color: 'blue' },
    { id: 'history', label: 'Sipariş Geçmişi', icon: History, color: 'purple' }
  ];

  const stats = [
    {
      label: 'Bekleyen Siparişler',
      value: statsData.pending.toString(),
      icon: Clock,
      color: 'orange',
      bgColor: 'bg-orange-100',
      iconColor: 'text-orange-600'
    },
    {
      label: 'Bugünkü Gelir',
      value: `₺${statsData.todayRevenue.toFixed(2)}`,
      icon: DollarSign,
      color: 'green',
      bgColor: 'bg-green-100',
      iconColor: 'text-green-600'
    },
    {
      label: 'Tamamlanan',
      value: statsData.completed.toString(),
      icon: CheckCircle2,
      color: 'blue',
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600'
    },
    {
      label: 'Toplam Sipariş',
      value: statsData.total.toString(),
      icon: TrendingUp,
      color: 'purple',
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-600'
    }
  ];

  // Tarih formatla
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Siparişi onayla
  const handleApproveOrder = async (orderId, event) => {
    if (event) {
      event.stopPropagation();
    }
    
    if (!user || !user.id) {
      showAlert('Kullanıcı bilgisi bulunamadı. Lütfen tekrar giriş yapın.', 'error');
      return;
    }
    
    showConfirm(
      'Siparişi Onayla',
      'Bu siparişi onaylamak istediğinizden emin misiniz?',
      () => {
        handleApproveOrderConfirm(orderId);
      }
    );
  };

  // Siparişi onayla (confirm'den sonra)
  const handleApproveOrderConfirm = async (orderId) => {
    setProcessingOrderId(orderId);
    try {
      // UserId'yi al (id, userId, UserId gibi farklı formatlar olabilir)
      const userId = user.id || user.userId || user.UserId || user.ID;
      if (!userId) {
        throw new Error('Kullanıcı ID bulunamadı');
      }
      
      await menuService.approveOrder(orderId, userId);
      showAlert('Sipariş başarıyla onaylandı!', 'success');
      
      // Siparişleri yeniden yükle
      const restaurantId = getRestaurantId();
      if (restaurantId) {
        const orders = await menuService.getPendingOrders(restaurantId);
        setPendingOrders(orders || []);
      }
      
      // Eğer seçili sipariş onaylandıysa, seçimi temizle
      if (selectedOrder && selectedOrder.orderId === orderId) {
        setSelectedOrder(null);
        setActiveTab('pending');
      }
    } catch (error) {
      console.error('Error approving order:', error);
      showAlert('Sipariş onaylanırken bir hata oluştu: ' + (error.message || 'Bilinmeyen hata'), 'error');
    } finally {
      setProcessingOrderId(null);
    }
  };

  // Siparişi reddet
  const handleRejectOrder = async () => {
    if (!orderToReject) return;
    
    if (!user || !user.id) {
      showAlert('Kullanıcı bilgisi bulunamadı. Lütfen tekrar giriş yapın.', 'error');
      return;
    }
    
    if (!rejectReason.trim()) {
      showAlert('Lütfen red sebebi giriniz.', 'warning');
      return;
    }

    setProcessingOrderId(orderToReject.orderId);
    try {
      // UserId'yi al (id, userId, UserId gibi farklı formatlar olabilir)
      const userId = user.id || user.userId || user.UserId || user.ID;
      if (!userId) {
        throw new Error('Kullanıcı ID bulunamadı');
      }
      
      // Reason'ı trim edilmiş olarak gönder ve boş olmadığından emin ol
      const trimmedReason = (rejectReason || '').trim();
      if (!trimmedReason) {
        showAlert('Lütfen red sebebi giriniz.', 'warning');
        setProcessingOrderId(null);
        return;
      }
      
      console.log('=== COMPONENT REJECT DEBUG ===');
      console.log('Rejecting order:', { 
        orderId: orderToReject.orderId, 
        userId, 
        rejectReason: rejectReason,
        trimmedReason: trimmedReason,
        reasonType: typeof trimmedReason,
        reasonLength: trimmedReason.length 
      });
      console.log('==============================');
      
      // Reason'un kesinlikle string ve dolu olduğundan emin ol
      if (!trimmedReason || trimmedReason.length === 0) {
        showAlert('Red sebebi boş olamaz!', 'warning');
        setProcessingOrderId(null);
        return;
      }
      
      await menuService.rejectOrder(orderToReject.orderId, userId, trimmedReason);
      showAlert('Sipariş başarıyla reddedildi!', 'success');
      
      // Siparişleri yeniden yükle
      const restaurantId = getRestaurantId();
      if (restaurantId) {
        const orders = await menuService.getPendingOrders(restaurantId);
        setPendingOrders(orders || []);
      }
      
      // Modal'ı kapat ve seçimi temizle
      setShowRejectModal(false);
      setRejectReason('');
      setOrderToReject(null);
      
      // Eğer seçili sipariş reddedildiyse, seçimi temizle
      if (selectedOrder && selectedOrder.orderId === orderToReject.orderId) {
        setSelectedOrder(null);
        setActiveTab('pending');
      }
    } catch (error) {
      console.error('Error rejecting order:', error);
      showAlert('Sipariş reddedilirken bir hata oluştu: ' + (error.message || 'Bilinmeyen hata'), 'error');
    } finally {
      setProcessingOrderId(null);
    }
  };

  // Reddet modal'ını aç
  const openRejectModal = (order, event) => {
    if (event) {
      event.stopPropagation();
    }
    setOrderToReject(order);
    setShowRejectModal(true);
    setRejectReason('');
  };

  // Modern Alert Modal Helper
  const showAlert = (message, type = 'info') => {
    setAlertMessage(message);
    setAlertType(type);
    setShowAlertModal(true);
  };

  // Modern Confirm Modal Helper
  const showConfirm = (title, message, onConfirm) => {
    setConfirmTitle(title);
    setConfirmMessage(message);
    setConfirmCallback(() => onConfirm);
    setShowConfirmModal(true);
  };

  // Siparişi tamamla
  const handleCompleteOrder = async (orderId, event) => {
    if (event) {
      event.stopPropagation();
    }
    
    if (!user || !user.id) {
      showAlert('Kullanıcı bilgisi bulunamadı. Lütfen tekrar giriş yapın.', 'error');
      return;
    }
    
    showConfirm(
      'Siparişi Tamamla',
      'Bu siparişi tamamlandı olarak işaretlemek istediğinizden emin misiniz?',
      () => {
        handleCompleteOrderConfirm(orderId);
      }
    );
  };

  // Siparişi tamamla (confirm'den sonra)
  const handleCompleteOrderConfirm = async (orderId) => {
    setProcessingOrderId(orderId);
    try {
      // UserId'yi al (id, userId, UserId gibi farklı formatlar olabilir)
      const userId = user.id || user.userId || user.UserId || user.ID;
      if (!userId) {
        throw new Error('Kullanıcı ID bulunamadı');
      }
      
      await menuService.completeOrder(orderId, userId);
      showAlert('Sipariş başarıyla tamamlandı olarak işaretlendi!', 'success');
      
      // Onaylanan siparişleri yeniden yükle
      const restaurantId = getRestaurantId();
      if (restaurantId) {
        const orders = await menuService.getApprovedOrders(restaurantId);
        setApprovedOrders(orders || []);
      }
    } catch (error) {
      console.error('Error completing order:', error);
      showAlert('Sipariş tamamlanırken bir hata oluştu: ' + (error.message || 'Bilinmeyen hata'), 'error');
    } finally {
      setProcessingOrderId(null);
    }
  };

  // Filtreleri sıfırla
  const handleResetFilters = () => {
    setHistoryFilters({
      orderNumber: '',
      createdAt: '',
      startDate: '',
      endDate: '',
      status: ''
    });
    setCurrentPage(1);
  };

  // Sayfalama hesaplamaları
  const totalPages = Math.ceil(historyOrders.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedOrders = historyOrders.slice(startIndex, endIndex);

  // Sayfa değiştir
  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Filtre değişikliklerini handle et
  const handleFilterChange = (field, value) => {
    setHistoryFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header */}
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="p-3 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl shadow-lg">
                <Package className="h-8 w-8 text-white" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-gray-900">Sipariş Yönetimi</h1>
                <p className="text-gray-600 mt-1">Restoranınıza ait siparişleri görüntüleyin ve yönetin</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              {restaurants && restaurants.length > 0 && (
                <div className="text-right">
                  <p className="text-sm text-gray-500">Restoran</p>
                  <p className="text-lg font-semibold text-gray-900">{restaurants[0]?.name || 'Restoran'}</p>
                </div>
              )}
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors shadow-md hover:shadow-lg"
              >
                <LogOut className="w-5 h-5" />
                <span className="font-medium">Çıkış Yap</span>
              </button>
            </div>
          </div>
        </div>

        {/* Statistics Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow duration-200"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-1">{stat.label}</p>
                    <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                  </div>
                  <div className={`${stat.bgColor} p-3 rounded-lg`}>
                    <Icon className={`h-6 w-6 ${stat.iconColor}`} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
          <div className="border-b border-gray-200 bg-gray-50">
            <nav className="flex space-x-1 px-4">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.id;
                const activeColorClass = tab.color === 'orange' ? 'text-orange-600' : 
                                        tab.color === 'blue' ? 'text-blue-600' : 
                                        tab.color === 'green' ? 'text-green-600' : 'text-purple-600';
                const activeBgClass = tab.color === 'orange' ? 'bg-orange-500' : 
                                     tab.color === 'blue' ? 'bg-blue-500' : 
                                     tab.color === 'green' ? 'bg-green-500' : 'bg-purple-500';
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`
                      flex items-center space-x-2 px-6 py-4 font-medium text-sm transition-all duration-200 relative
                      ${
                        isActive
                          ? `${activeColorClass} bg-white`
                          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                      }
                    `}
                  >
                    <Icon className={`w-5 h-5 ${isActive ? '' : 'opacity-70'}`} />
                    <span>{tab.label}</span>
                    {isActive && (
                      <div className={`absolute bottom-0 left-0 right-0 h-0.5 ${activeBgClass}`}></div>
                    )}
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Tab Content */}
          <div className="p-6">
            {activeTab === 'approved' && (
              <div className="space-y-4">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-900">Onaylanan Siparişler</h2>
                  <div className="flex items-center space-x-2 text-green-600">
                    <CheckCircle2 className="w-5 h-5" />
                    <span className="text-sm font-medium">Canlı Güncelleme</span>
                  </div>
                </div>

                {approvedLoading ? (
                  <div className="flex items-center justify-center py-12">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
                  </div>
                ) : approvedOrders.length === 0 ? (
                  <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border-2 border-green-200 p-12 text-center">
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-4">
                      <CheckCircle2 className="w-10 h-10 text-green-600" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Henüz Onaylanan Sipariş Yok</h3>
                    <p className="text-gray-600 mb-1">Onaylanan siparişler burada görüntülenecek</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {approvedOrders.map((order) => (
                      <div
                        key={order.orderId}
                        className="bg-white border-2 border-green-200 rounded-xl p-6 hover:shadow-lg transition-all duration-200 cursor-pointer"
                        onClick={() => {
                          setSelectedOrder(order);
                          setActiveTab('detail');
                        }}
                      >
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <div className="px-3 py-1 bg-green-100 text-green-700 rounded-lg font-semibold text-sm">
                                #{order.orderNumber}
                              </div>
                              {order.tableNumber && (
                                <div className="flex items-center space-x-1 text-gray-600">
                                  <MapPin className="w-4 h-4" />
                                  <span className="text-sm font-medium">Masa {order.tableNumber}</span>
                                </div>
                              )}
                              <div className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg text-xs font-medium">
                                {order.statusDisplay || 'Onaylandı'}
                              </div>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                              {(order.customerName || order.customerPhone) && (
                                <div className="space-y-2">
                                  {order.customerName && (
                                    <div className="flex items-center space-x-2 text-gray-700">
                                      <User className="w-4 h-4 text-gray-500" />
                                      <span className="text-sm">{order.customerName}</span>
                                    </div>
                                  )}
                                  {order.customerPhone && (
                                    <div className="flex items-center space-x-2 text-gray-700">
                                      <Phone className="w-4 h-4 text-gray-500" />
                                      <span className="text-sm">{order.customerPhone}</span>
                                    </div>
                                  )}
                                  {order.customerAddress && (
                                    <div className="flex items-start space-x-2 text-gray-700">
                                      <MapPin className="w-4 h-4 text-gray-500 mt-0.5 flex-shrink-0" />
                                      <span className="text-sm line-clamp-4 break-words">{order.customerAddress}</span>
                                    </div>
                                  )}
                                </div>
                              )}
                              
                              <div className="flex items-center space-x-2 text-gray-700">
                                <Calendar className="w-4 h-4 text-gray-500" />
                                <span className="text-sm">{formatDate(order.createdDate)}</span>
                              </div>
                              
                              {order.approvedDate && (
                                <div className="flex items-center space-x-2 text-green-700">
                                  <CheckCircle2 className="w-4 h-4" />
                                  <span className="text-sm">Onay: {formatDate(order.approvedDate)}</span>
                                </div>
                              )}
                            </div>

                            {order.notes && (
                              <div className="mt-3 p-3 bg-gray-50 rounded-lg">
                                <p className="text-sm text-gray-600">
                                  <span className="font-medium">Not: </span>
                                  {order.notes}
                                </p>
                              </div>
                            )}
                          </div>
                          
                          <div className="ml-4 text-right">
                            <div className="text-2xl font-bold text-green-600">
                              ₺{order.totalAmount?.toFixed(2) || '0.00'}
                            </div>
                            <div className="text-sm text-gray-500 mt-1">
                              {order.items?.length || 0} ürün
                            </div>
                          </div>
                        </div>

                        {/* Sipariş Öğeleri Özeti */}
                        {order.items && order.items.length > 0 && (
                          <div className="mt-4 pt-4 border-t border-gray-200">
                            <div className="flex items-center space-x-2 mb-2">
                              <Receipt className="w-4 h-4 text-gray-500" />
                              <span className="text-sm font-medium text-gray-700">Sipariş Özeti:</span>
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {order.items.slice(0, 3).map((item, index) => (
                                <div key={index} className="px-3 py-1 bg-gray-100 rounded-lg text-xs text-gray-700">
                                  {item.quantity}x {item.productName}
                                </div>
                              ))}
                              {order.items.length > 3 && (
                                <div className="px-3 py-1 bg-gray-100 rounded-lg text-xs text-gray-700">
                                  +{order.items.length - 3} daha
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Tamamlandı Butonu */}
                        <div className="mt-4 pt-4 border-t border-gray-200 flex items-center justify-end">
                          <button
                            onClick={(e) => handleCompleteOrder(order.orderId, e)}
                            disabled={processingOrderId === order.orderId}
                            className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            <CheckCircle2 className="w-4 h-4" />
                            <span className="font-medium">
                              {processingOrderId === order.orderId ? 'Tamamlanıyor...' : 'Tamamlandı'}
                            </span>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {activeTab === 'pending' && (
              <div className="space-y-4">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-900">Bekleyen Siparişler</h2>
                  <div className="flex items-center space-x-2 text-orange-600">
                    <Clock className="w-5 h-5" />
                    <span className="text-sm font-medium">Canlı Güncelleme</span>
                  </div>
                </div>

                {loading ? (
                  <div className="flex items-center justify-center py-12">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
                  </div>
                ) : pendingOrders.length === 0 ? (
                  <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl border-2 border-orange-200 p-12 text-center">
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-100 rounded-full mb-4">
                      <Clock className="w-10 h-10 text-orange-600" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Henüz Bekleyen Sipariş Yok</h3>
                    <p className="text-gray-600 mb-1">Yeni siparişler geldiğinde burada görüntülenecek</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {pendingOrders.map((order) => (
                      <div
                        key={order.orderId}
                        className="bg-white border-2 border-orange-200 rounded-xl p-6 hover:shadow-lg transition-all duration-200 cursor-pointer"
                        onClick={() => {
                          setSelectedOrder(order);
                          setActiveTab('detail');
                        }}
                      >
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <div className="px-3 py-1 bg-orange-100 text-orange-700 rounded-lg font-semibold text-sm">
                                #{order.orderNumber}
                              </div>
                              {order.tableNumber && (
                                <div className="flex items-center space-x-1 text-gray-600">
                                  <MapPin className="w-4 h-4" />
                                  <span className="text-sm font-medium">Masa {order.tableNumber}</span>
                                </div>
                              )}
                              <div className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg text-xs font-medium">
                                {order.statusDisplay || 'Beklemede'}
                              </div>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                              {(order.customerName || order.customerPhone) && (
                                <div className="space-y-2">
                                  {order.customerName && (
                                    <div className="flex items-center space-x-2 text-gray-700">
                                      <User className="w-4 h-4 text-gray-500" />
                                      <span className="text-sm">{order.customerName}</span>
                                    </div>
                                  )}
                                  {order.customerPhone && (
                                    <div className="flex items-center space-x-2 text-gray-700">
                                      <Phone className="w-4 h-4 text-gray-500" />
                                      <span className="text-sm">{order.customerPhone}</span>
                                    </div>
                                  )}
                                  {order.customerAddress && (
                                    <div className="flex items-start space-x-2 text-gray-700">
                                      <MapPin className="w-4 h-4 text-gray-500 mt-0.5 flex-shrink-0" />
                                      <span className="text-sm line-clamp-4 break-words">{order.customerAddress}</span>
                                    </div>
                                  )}
                                </div>
                              )}
                              
                              <div className="flex items-center space-x-2 text-gray-700">
                                <Calendar className="w-4 h-4 text-gray-500" />
                                <span className="text-sm">{formatDate(order.createdDate)}</span>
                              </div>
                            </div>

                            {order.notes && (
                              <div className="mt-3 p-3 bg-gray-50 rounded-lg">
                                <p className="text-sm text-gray-600">
                                  <span className="font-medium">Not: </span>
                                  {order.notes}
                                </p>
                              </div>
                            )}
                          </div>
                          
                          <div className="ml-4 text-right">
                            <div className="text-2xl font-bold text-orange-600">
                              ₺{order.totalAmount?.toFixed(2) || '0.00'}
                            </div>
                            <div className="text-sm text-gray-500 mt-1">
                              {order.items?.length || 0} ürün
                            </div>
                          </div>
                        </div>

                        {/* Sipariş Öğeleri Özeti */}
                        {order.items && order.items.length > 0 && (
                          <div className="mt-4 pt-4 border-t border-gray-200">
                            <div className="flex items-center space-x-2 mb-2">
                              <Receipt className="w-4 h-4 text-gray-500" />
                              <span className="text-sm font-medium text-gray-700">Sipariş Özeti:</span>
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {order.items.slice(0, 3).map((item, index) => (
                                <div key={index} className="px-3 py-1 bg-gray-100 rounded-lg text-xs text-gray-700">
                                  {item.quantity}x {item.productName}
                                </div>
                              ))}
                              {order.items.length > 3 && (
                                <div className="px-3 py-1 bg-gray-100 rounded-lg text-xs text-gray-700">
                                  +{order.items.length - 3} daha
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Onayla ve Reddet Butonları */}
                        <div className="mt-4 pt-4 border-t border-gray-200 flex items-center justify-end space-x-3">
                          <button
                            onClick={(e) => handleApproveOrder(order.orderId, e)}
                            disabled={processingOrderId === order.orderId}
                            className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            <Check className="w-4 h-4" />
                            <span className="font-medium">
                              {processingOrderId === order.orderId ? 'Onaylanıyor...' : 'Onayla'}
                            </span>
                          </button>
                          <button
                            onClick={(e) => openRejectModal(order, e)}
                            disabled={processingOrderId === order.orderId}
                            className="flex items-center space-x-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            <X className="w-4 h-4" />
                            <span className="font-medium">Reddet</span>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {activeTab === 'detail' && (
              <div className="space-y-4">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-900">Sipariş Detayı</h2>
                  {selectedOrder && (
                    <button
                      onClick={() => {
                        setSelectedOrder(null);
                        setActiveTab('pending');
                      }}
                      className="text-sm text-gray-600 hover:text-gray-900"
                    >
                      ← Geri Dön
                    </button>
                  )}
                </div>

                {!selectedOrder ? (
                  <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border-2 border-blue-200 p-12 text-center">
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 rounded-full mb-4">
                      <Package className="w-10 h-10 text-blue-600" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Sipariş Seçin</h3>
                    <p className="text-gray-600 mb-1">Detaylarını görmek istediğiniz siparişi seçin</p>
                    <button
                      onClick={() => setActiveTab('pending')}
                      className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                      Bekleyen Siparişlere Git
                    </button>
                  </div>
                ) : (
                  <div className="space-y-6">
                    {/* Sipariş Bilgileri */}
                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border-2 border-blue-200 p-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <h3 className="text-lg font-bold text-gray-900 mb-4">Sipariş Bilgileri</h3>
                          <div className="space-y-2">
                            <div className="flex items-center space-x-2">
                              <span className="text-sm font-medium text-gray-600">Sipariş No:</span>
                              <span className="text-sm text-gray-900 font-semibold">#{selectedOrder.orderNumber}</span>
                            </div>
                            {selectedOrder.tableNumber && (
                              <div className="flex items-center space-x-2">
                                <MapPin className="w-4 h-4 text-gray-500" />
                                <span className="text-sm text-gray-600">Masa: {selectedOrder.tableNumber}</span>
                              </div>
                            )}
                            <div className="flex items-center space-x-2">
                              <Calendar className="w-4 h-4 text-gray-500" />
                              <span className="text-sm text-gray-600">{formatDate(selectedOrder.createdDate)}</span>
                            </div>
                            <div className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg inline-block text-xs font-medium">
                              {selectedOrder.statusDisplay || 'Beklemede'}
                            </div>
                          </div>
                        </div>
                        
                        <div>
                          <h3 className="text-lg font-bold text-gray-900 mb-4">Müşteri Bilgileri</h3>
                          <div className="space-y-2">
                            {selectedOrder.customerName && (
                              <div className="flex items-center space-x-2">
                                <User className="w-4 h-4 text-gray-500" />
                                <span className="text-sm text-gray-600">{selectedOrder.customerName}</span>
                              </div>
                            )}
                            {selectedOrder.customerPhone && (
                              <div className="flex items-center space-x-2">
                                <Phone className="w-4 h-4 text-gray-500" />
                                <span className="text-sm text-gray-600">{selectedOrder.customerPhone}</span>
                              </div>
                            )}
                            {selectedOrder.customerAddress && (
                              <div className="flex items-start space-x-2">
                                <MapPin className="w-4 h-4 text-gray-500 mt-0.5 flex-shrink-0" />
                                <span className="text-sm text-gray-600 line-clamp-4 break-words">{selectedOrder.customerAddress}</span>
                              </div>
                            )}
                            {!selectedOrder.customerName && !selectedOrder.customerPhone && (
                              <p className="text-sm text-gray-500">Müşteri bilgisi yok</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {selectedOrder.notes && (
                        <div className="mt-4 p-4 bg-white rounded-lg">
                          <p className="text-sm font-medium text-gray-700 mb-1">Notlar:</p>
                          <p className="text-sm text-gray-600">{selectedOrder.notes}</p>
                        </div>
                      )}
                    </div>

                    {/* Sipariş Öğeleri */}
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-4">Sipariş Öğeleri</h3>
                      <div className="space-y-3">
                        {selectedOrder.items?.map((item, index) => (
                          <div key={index} className="bg-white border border-gray-200 rounded-lg p-4">
                            <div className="flex items-start justify-between mb-2">
                              <div className="flex-1">
                                <div className="flex items-center space-x-3">
                                  {item.productImage && (
                                    <img
                                      src={`${API_BASE_URL}${item.productImage}`}
                                      alt={item.productName}
                                      className="w-16 h-16 object-cover rounded-lg"
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                      }}
                                    />
                                  )}
                                  <div>
                                    <h4 className="font-semibold text-gray-900">{item.productName}</h4>
                                    <p className="text-sm text-gray-600">Adet: {item.quantity}</p>
                                    {item.variants && item.variants.length > 0 && (
                                      <p className="text-xs text-gray-500 mt-1">
                                        Varyant: {item.variants.map(v => v.variantName).join(', ')}
                                      </p>
                                    )}
                                    {item.addons && item.addons.length > 0 && (
                                      <p className="text-xs text-gray-500 mt-1">
                                        Eklentiler: {item.addons.map(a => a.addonName).join(', ')}
                                      </p>
                                    )}
                                    {item.notes && (
                                      <p className="text-xs text-gray-500 mt-1 italic">Not: {item.notes}</p>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="text-right ml-4">
                                <p className="font-bold text-gray-900">₺{item.totalPrice?.toFixed(2) || '0.00'}</p>
                                <p className="text-xs text-gray-500">₺{item.unitPrice?.toFixed(2) || '0.00'}/adet</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Toplam */}
                    <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-6 text-white">
                      <div className="flex items-center justify-between">
                        <span className="text-xl font-bold">Toplam Tutar</span>
                        <span className="text-3xl font-bold">₺{selectedOrder.totalAmount?.toFixed(2) || '0.00'}</span>
                      </div>
                    </div>

                    {/* Butonlar - Sipariş durumuna göre */}
                    {selectedOrder.status === 1 ? (
                      // Status 1 (Approved/Onaylandı) için: Tamamlandı butonu
                      <div className="flex items-center justify-end space-x-3 mt-6">
                        <button
                          onClick={() => handleCompleteOrder(selectedOrder.orderId)}
                          disabled={processingOrderId === selectedOrder.orderId}
                          className="flex items-center space-x-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-md hover:shadow-lg"
                        >
                          <CheckCircle2 className="w-5 h-5" />
                          <span>
                            {processingOrderId === selectedOrder.orderId ? 'Tamamlanıyor...' : 'Tamamlandı'}
                          </span>
                        </button>
                      </div>
                    ) : selectedOrder.status === 0 ? (
                      // Status 0 (Pending/Beklemede) için: Onayla ve Reddet butonları
                      <div className="flex items-center justify-end space-x-3 mt-6">
                        <button
                          onClick={() => handleApproveOrder(selectedOrder.orderId)}
                          disabled={processingOrderId === selectedOrder.orderId}
                          className="flex items-center space-x-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-md hover:shadow-lg"
                        >
                          <Check className="w-5 h-5" />
                          <span>
                            {processingOrderId === selectedOrder.orderId ? 'Onaylanıyor...' : 'Onayla'}
                          </span>
                        </button>
                        <button
                          onClick={() => openRejectModal(selectedOrder)}
                          disabled={processingOrderId === selectedOrder.orderId}
                          className="flex items-center space-x-2 px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-md hover:shadow-lg"
                        >
                          <X className="w-5 h-5" />
                          <span>Reddet</span>
                        </button>
                      </div>
                    ) : (
                      // Diğer durumlar (Rejected/Reddedildi, Completed/Tamamlandı, vb.) için: Buton gösterilmez
                      null
                    )}
                  </div>
                )}
              </div>
            )}

            {activeTab === 'history' && (
              <div className="space-y-4">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-900">Geçmiş Siparişler</h2>
                  <div className="flex items-center space-x-2 text-green-600">
                    <History className="w-5 h-5" />
                    <span className="text-sm font-medium">Geçmiş Kayıtlar</span>
                  </div>
                </div>

                {/* Filtreler */}
                <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Filtreler</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {/* Sipariş Numarası */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Sipariş Numarası
                      </label>
                      <input
                        type="text"
                        value={historyFilters.orderNumber}
                        onChange={(e) => handleFilterChange('orderNumber', e.target.value)}
                        placeholder="Sipariş numarası giriniz"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      />
                    </div>

                    {/* Oluşturulma Tarihi */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Oluşturulma Tarihi
                      </label>
                      <input
                        type="date"
                        value={historyFilters.createdAt}
                        onChange={(e) => handleFilterChange('createdAt', e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      />
                    </div>

                    {/* Başlangıç Tarihi */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Başlangıç Tarihi
                      </label>
                      <input
                        type="date"
                        value={historyFilters.startDate}
                        onChange={(e) => handleFilterChange('startDate', e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      />
                    </div>

                    {/* Bitiş Tarihi */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Bitiş Tarihi
                      </label>
                      <input
                        type="date"
                        value={historyFilters.endDate}
                        onChange={(e) => handleFilterChange('endDate', e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      />
                    </div>

                    {/* Durum */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Durum
                      </label>
                      <select
                        value={historyFilters.status}
                        onChange={(e) => handleFilterChange('status', e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      >
                        <option value="">Tümü</option>
                        <option value="0">Beklemede</option>
                        <option value="1">Onaylandı</option>
                        <option value="2">Reddedildi</option>
                        <option value="3">Tamamlandı</option>
                      </select>
                    </div>

                    {/* Ara Butonu */}
                    <div className="flex items-end">
                      <button
                        onClick={handleSearch}
                        disabled={historyLoading}
                        className="w-full px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                      >
                        <Search className="w-4 h-4" />
                        <span>{historyLoading ? 'Aranıyor...' : 'Ara'}</span>
                      </button>
                    </div>

                    {/* Filtreleri Sıfırla Butonu */}
                    <div className="flex items-end">
                      <button
                        onClick={handleResetFilters}
                        className="w-full px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                      >
                        Filtreleri Sıfırla
                      </button>
                    </div>
                  </div>
                </div>

                {/* Sipariş Listesi - Tablo Görünümü */}
                {historyLoading ? (
                  <div className="flex items-center justify-center py-12">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
                  </div>
                ) : historyOrders.length === 0 ? (
                  <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border-2 border-green-200 p-12 text-center">
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-4">
                      <History className="w-10 h-10 text-green-600" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Henüz Geçmiş Sipariş Yok</h3>
                    <p className="text-gray-600 mb-1">Filtre kriterlerinize uygun sipariş bulunamadı</p>
                  </div>
                ) : (
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                    {/* Tablo Başlığı */}
                    <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
                      <div className="grid grid-cols-12 gap-4 text-sm font-medium text-gray-500 uppercase tracking-wider">
                        <div className="col-span-1">Sipariş No</div>
                        <div className="col-span-2">Tarih</div>
                        <div className="col-span-1">Masa</div>
                        <div className="col-span-2">Müşteri</div>
                        <div className="col-span-2">Ürün Sayısı</div>
                        <div className="col-span-2">Toplam Tutar</div>
                        <div className="col-span-1">Durum</div>
                        <div className="col-span-1">İşlemler</div>
                      </div>
                    </div>
                    {/* Tablo İçeriği */}
                    <div className="divide-y divide-gray-200">
                      {paginatedOrders.map((order) => (
                        <div
                          key={order.orderId}
                          className="px-6 py-4 hover:bg-gray-50 transition-colors"
                        >
                          <div className="grid grid-cols-12 gap-4 items-center">
                            {/* Sipariş No */}
                            <div className="col-span-1">
                              <div className="px-2 py-1 bg-green-100 text-green-700 rounded font-semibold text-sm inline-block">
                                #{order.orderNumber}
                              </div>
                            </div>

                            {/* Tarih */}
                            <div className="col-span-2">
                              <div className="flex items-center space-x-2 text-gray-700">
                                <Calendar className="w-4 h-4 text-gray-400" />
                                <span className="text-sm">{formatDate(order.createdDate)}</span>
                              </div>
                            </div>

                            {/* Masa */}
                            <div className="col-span-1">
                              {order.tableNumber ? (
                                <div className="flex items-center space-x-1 text-gray-600">
                                  <MapPin className="w-4 h-4 text-gray-400" />
                                  <span className="text-sm">{order.tableNumber}</span>
                                </div>
                              ) : (
                                <span className="text-sm text-gray-400">-</span>
                              )}
                            </div>

                            {/* Müşteri */}
                            <div className="col-span-2">
                              {order.customerName || order.customerPhone ? (
                                <div className="space-y-1">
                                  {order.customerName && (
                                    <div className="flex items-center space-x-1 text-gray-700">
                                      <User className="w-4 h-4 text-gray-400" />
                                      <span className="text-sm truncate">{order.customerName}</span>
                                    </div>
                                  )}
                                  {order.customerPhone && (
                                    <div className="flex items-center space-x-1 text-gray-600">
                                      <Phone className="w-3 h-3 text-gray-400" />
                                      <span className="text-xs">{order.customerPhone}</span>
                                    </div>
                                  )}
                                  {order.customerAddress && (
                                    <div className="flex items-start space-x-1 text-gray-600">
                                      <MapPin className="w-3 h-3 text-gray-400 mt-0.5 flex-shrink-0" />
                                      <span className="text-xs line-clamp-4 break-words">{order.customerAddress}</span>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <span className="text-sm text-gray-400">-</span>
                              )}
                            </div>

                            {/* Ürün Sayısı */}
                            <div className="col-span-2">
                              <div className="flex items-center space-x-2 text-gray-700">
                                <Receipt className="w-4 h-4 text-gray-400" />
                                <span className="text-sm font-medium">
                                  {order.items?.length || 0} ürün
                                </span>
                              </div>
                            </div>

                            {/* Toplam Tutar */}
                            <div className="col-span-2">
                              <span className="text-lg font-bold text-green-600">
                                ₺{order.totalAmount?.toFixed(2) || '0.00'}
                              </span>
                            </div>

                            {/* Durum */}
                            <div className="col-span-1">
                              <div className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium inline-block">
                                {order.statusDisplay || 'Bilinmiyor'}
                              </div>
                            </div>

                            {/* İşlemler */}
                            <div className="col-span-1">
                              <button
                                onClick={() => {
                                  setSelectedOrder(order);
                                  setActiveTab('detail');
                                }}
                                className="px-3 py-1.5 bg-green-600 text-white rounded hover:bg-green-700 transition-colors text-sm font-medium"
                              >
                                Detay
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                      <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
                        <div className="flex items-center justify-between">
                          <div className="text-sm text-gray-700">
                            Toplam <span className="font-medium">{historyOrders.length}</span> kayıt
                            {' '}(Sayfa <span className="font-medium">{currentPage}</span> / <span className="font-medium">{totalPages}</span>)
                          </div>
                          <div className="flex items-center space-x-2">
                            <button
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                              className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-1"
                            >
                              <ChevronLeft className="w-4 h-4" />
                              <span>Önceki</span>
                            </button>
                            
                            <div className="flex items-center space-x-1">
                              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
                                // Sadece ilk, son ve mevcut sayfanın yakınındaki sayfaları göster
                                if (
                                  page === 1 ||
                                  page === totalPages ||
                                  (page >= currentPage - 1 && page <= currentPage + 1)
                                ) {
                                  return (
                                    <button
                                      key={page}
                                      onClick={() => handlePageChange(page)}
                                      className={`px-3 py-1.5 rounded-lg text-sm font-medium ${
                                        currentPage === page
                                          ? 'bg-green-600 text-white'
                                          : 'border border-gray-300 text-gray-700 bg-white hover:bg-gray-50'
                                      }`}
                                    >
                                      {page}
                                    </button>
                                  );
                                } else if (
                                  page === currentPage - 2 ||
                                  page === currentPage + 2
                                ) {
                                  return (
                                    <span key={page} className="px-2 text-gray-500">
                                      ...
                                    </span>
                                  );
                                }
                                return null;
                              })}
                            </div>

                            <button
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-1"
                            >
                              <span>Sonraki</span>
                              <ChevronRight className="w-4 h-4" />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Reddet Modal */}
        {showRejectModal && orderToReject && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Siparişi Reddet</h3>
              <p className="text-sm text-gray-600 mb-2">
                Sipariş No: <span className="font-semibold">#{orderToReject.orderNumber}</span>
              </p>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Red Sebebi <span className="text-red-500">*</span>
                </label>
                <textarea
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  placeholder="Red sebebini giriniz..."
                  rows={4}
                  disabled={processingOrderId === orderToReject.orderId}
                />
              </div>
              <div className="flex items-center justify-end space-x-3">
                <button
                  onClick={() => {
                    setShowRejectModal(false);
                    setRejectReason('');
                    setOrderToReject(null);
                  }}
                  disabled={processingOrderId === orderToReject.orderId}
                  className="px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  İptal
                </button>
                <button
                  onClick={handleRejectOrder}
                  disabled={processingOrderId === orderToReject.orderId || !rejectReason.trim()}
                  className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {processingOrderId === orderToReject.orderId ? 'Reddediliyor...' : 'Reddet'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Alert Modal */}
        {showAlertModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 animate-in fade-in zoom-in duration-200">
              <div className="flex items-start space-x-4">
                <div className={`flex-shrink-0 p-3 rounded-full ${
                  alertType === 'success' ? 'bg-green-100' :
                  alertType === 'error' ? 'bg-red-100' :
                  alertType === 'warning' ? 'bg-yellow-100' :
                  'bg-blue-100'
                }`}>
                  {alertType === 'success' ? (
                    <CheckCircle2 className="w-6 h-6 text-green-600" />
                  ) : alertType === 'error' ? (
                    <AlertCircle className="w-6 h-6 text-red-600" />
                  ) : alertType === 'warning' ? (
                    <AlertTriangle className="w-6 h-6 text-yellow-600" />
                  ) : (
                    <Info className="w-6 h-6 text-blue-600" />
                  )}
                </div>
                <div className="flex-1">
                  <h3 className={`text-lg font-semibold mb-2 ${
                    alertType === 'success' ? 'text-green-900' :
                    alertType === 'error' ? 'text-red-900' :
                    alertType === 'warning' ? 'text-yellow-900' :
                    'text-blue-900'
                  }`}>
                    {alertType === 'success' ? 'Başarılı' :
                     alertType === 'error' ? 'Hata' :
                     alertType === 'warning' ? 'Uyarı' :
                     'Bilgi'}
                  </h3>
                  <p className="text-gray-700 mb-4">{alertMessage}</p>
                  <div className="flex justify-end">
                    <button
                      onClick={() => setShowAlertModal(false)}
                      className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                        alertType === 'success' ? 'bg-green-600 hover:bg-green-700 text-white' :
                        alertType === 'error' ? 'bg-red-600 hover:bg-red-700 text-white' :
                        alertType === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700 text-white' :
                        'bg-blue-600 hover:bg-blue-700 text-white'
                      }`}
                    >
                      Tamam
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Confirm Modal */}
        {showConfirmModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 animate-in fade-in zoom-in duration-200">
              <div className="flex items-start space-x-4 mb-4">
                <div className="flex-shrink-0 p-3 bg-blue-100 rounded-full">
                  <AlertCircle className="w-6 h-6 text-blue-600" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{confirmTitle}</h3>
                  <p className="text-gray-700">{confirmMessage}</p>
                </div>
              </div>
              <div className="flex items-center justify-end space-x-3">
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    setConfirmCallback(null);
                    setConfirmMessage('');
                    setConfirmTitle('');
                  }}
                  className="px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                >
                  İptal
                </button>
                <button
                  onClick={() => {
                    if (confirmCallback) {
                      confirmCallback();
                    }
                    setShowConfirmModal(false);
                    setConfirmCallback(null);
                    setConfirmMessage('');
                    setConfirmTitle('');
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                >
                  Onayla
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingOrdersManagement;

